import * as React from 'react';
import styled from 'styled-components';

const Vitrine = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 24px;
  margin-top: 32px;
  min-height: 260px;
`;

const Aparelho = styled.div<{largura: number; altura: number; raio: number}>`
  width: ${(props) => props.largura}px;
  height: ${(props) => props.altura}px;
  border-radius: ${(props) => props.raio}px;
  border: 3px solid rgba(255, 255, 255, 0.55);
  background: #0b1b33;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
  padding: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
`;

const Tela = styled.div`
  flex: 1;
  border-radius: 10px;
  background: linear-gradient(160deg, #12233f 0%, #0b1b33 100%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  color: #fff;
`;

const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Foto = styled.div<{tamanho: number}>`
  width: ${(props) => props.tamanho}px;
  height: ${(props) => props.tamanho}px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Linha = styled.div<{largura: string; altura?: number}>`
  width: ${(props) => props.largura};
  height: ${(props) => props.altura ?? 6}px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
`;

const Cartao = styled.div`
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Legenda = styled.p`
  margin: 16px 0 0;
  font-size: 13px;
  opacity: 0.75;
  text-align: center;
`;

interface Props {
  avatarUrl?: string | null;
  nome?: string | null;
}

const Iniciais: React.FC<{nome?: string | null}> = ({nome}) => (
  <span
    style={{
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 11,
      fontWeight: 700,
    }}>
    {(nome ?? '').trim().charAt(0).toLocaleUpperCase('pt-BR') || '?'}
  </span>
);

// Nao existe mockup de tablet nos assets do projeto — so preview-smartphone.png,
// que e uma imagem raster de um unico aparelho. As molduras aqui sao CSS, entao
// dao conta de qualquer tamanho de tela e ainda recebem o avatar de verdade.
export const RegisterDeviceShowcase: React.FC<Props> = ({avatarUrl, nome}) => {
  const foto = (tamanho: number) => (
    <Foto tamanho={tamanho}>
      {avatarUrl ? <img src={avatarUrl} alt="" /> : <Iniciais nome={nome} />}
    </Foto>
  );

  return (
    <>
      <Vitrine>
        <Aparelho largura={132} altura={200} raio={18} aria-hidden="true">
          <Tela>
            <Topo>
              {foto(26)}
              <Linha largura="60%" />
            </Topo>
            <Cartao>
              <Linha largura="80%" />
              <Linha largura="55%" altura={5} />
            </Cartao>
            <Cartao>
              <Linha largura="70%" />
              <Linha largura="40%" altura={5} />
            </Cartao>
          </Tela>
        </Aparelho>

        <Aparelho largura={188} altura={244} raio={20} aria-hidden="true">
          <Tela>
            <Topo>
              {foto(34)}
              <div style={{display: 'flex', flexDirection: 'column', gap: 5, flex: 1}}>
                <Linha largura="70%" />
                <Linha largura="45%" altura={5} />
              </div>
            </Topo>
            <div style={{display: 'flex', gap: 8}}>
              <Cartao style={{flex: 1}}>
                <Linha largura="90%" />
                <Linha largura="60%" altura={5} />
              </Cartao>
              <Cartao style={{flex: 1}}>
                <Linha largura="80%" />
                <Linha largura="50%" altura={5} />
              </Cartao>
            </div>
            <Cartao>
              <Linha largura="85%" />
              <Linha largura="65%" altura={5} />
            </Cartao>
          </Tela>
        </Aparelho>

        <Aparelho largura={112} altura={172} raio={16} aria-hidden="true">
          <Tela>
            <Topo>{foto(22)}</Topo>
            <Cartao>
              <Linha largura="85%" />
              <Linha largura="50%" altura={5} />
            </Cartao>
            <Linha largura="70%" altura={5} />
          </Tela>
        </Aparelho>
      </Vitrine>

      <Legenda>
        {avatarUrl
          ? 'É assim que seus alunos vão ver você.'
          : 'Envie sua foto no primeiro passo para se ver aqui.'}
      </Legenda>
    </>
  );
};
